var classes = {"radioGroupInputs":"EiUrp"};

export { classes as default };
